
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum ProductPlanSettingType {
	None = 0,
	FreeProductPlan = 1,
	KeepExistingProductPlanOnDiscontinuation = 2,
	CannotBeDiscontinued = 3
}
export namespace ProductPlanSettingType {
	export function getKeys(): Map<ProductPlanSettingType, string> {
		return new Map([[0, 'None'], [1, 'FreeProductPlan'], [2, 'KeepExistingProductPlanOnDiscontinuation'], [3, 'CannotBeDiscontinued']]);
	}
}
